import React, { useEffect } from "react";
import { updateGroup } from "../../../services/apiservices/groups";
import styles from "../employee.module.scss";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import { X } from "lucide-react";
import MultiSelectWithCheckbox from "../../../components/SelectField/MulitpleSelectNew";
import { trackEvent, CMS_EVENTS } from "../../../services/apiservices/analytics";

const EditGroup = (props) => {
  const [newGroup, setNewGroup] = React.useState(props?.group?.title);
  const [newGroupDescription, setNewGroupDescription] = React.useState(
    props?.group?.description
  );
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const [selectedOldEmployees, setSelectedOldEmployees] = React.useState([]);
  const [newGroupType, setNewGroupType] = React.useState(props?.group?.type);
  const [errors, setErrors] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const InitFields = () => {
    setNewGroup(props?.group?.title);
    setNewGroupDescription(props?.group?.description);
    setNewGroupType(props?.group?.type);
    setSelectedOptions(props?.group?.employeeId);
    setSelectedOldEmployees(props?.group?.employeeId);
  };

  const { employeeList } = props;

  const employeeOptions = [
    ...employeeList?.map((employee) => ({
      value: employee?.id,
      label: `${employee?.firstName} ${employee?.lastName}`,
      email: employee?.email,
      timeZone: employee?.timeZone
    }))
  ];

  const GroupType = [
    { label: "Residential", value: "Residential" },
    { label: "Commercial", value: "Commercial" },
    { label: "Custom", value: "Custom" },
  ];

  useEffect(() => {
    InitFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.group]);
  const onEditGroup = async () => {
    if (props?.group?.groupId) {
      setIsLoading(true);
      await updateGroup(
        props?.group?.groupId,
        {
          title: newGroup,
          description: newGroupDescription,
          type: newGroupType,
          employeeId: selectedOptions,
          oldEmployeeId: selectedOldEmployees
        },
        (res) => {
          setIsLoading(false);
          props?.setIsEditOpen(false);
          props?.onSuccess && props?.onSuccess();
          trackEvent(CMS_EVENTS.GROUP_UPDATED, {
            group_id: props?.group?.groupId,
            group_name: newGroup,
          });
        },
        (resError) => {
          setIsLoading(false);
        }
      );
    } else {
      setIsLoading(false);
      setErrors({ newGroup: "Title is Required" });
    }
  };

  return (
    <>
      {props?.isEditOpen && (
        <div className={`${styles.overlay}  ${!props?.isEditOpen ? styles.closing : ""}`}>
          <div
            className={`${styles.modal} dark:bg-[#1A1F2C] ${props?.isEditOpen ? styles.modalOpen : ""
              }`}
          >
            <div className={`${styles.header} d-flex flex-space-between`} >
              <div>
                <h2 className={`${styles.title} dark:text-white`}>Edit Group</h2>
                <p className={`${styles.description} dark:text-white`}>Update group information.</p>
              </div>
              <div onClick={() => props?.setIsEditOpen(false)}> <X className="h-4 w-4 dark:text-white" /></div>
            </div>
            <div className="p-15">
              <div className="mb-15">
                <label htmlFor="name" className="text-sm font-medium dark:text-white">
                  Group Name
                </label>
                <Input
                  id="newGroup"
                  onChange={(event) => {
                    setErrors({ newGroup: "" });
                    setNewGroup(event.target.value);
                  }}
                  value={newGroup ? newGroup : ""}
                  placeholder="Enter group name"
                  className="mt-8"
                />
              </div>
              {typeof errors?.newGroup !== "undefined" &&
                errors?.newGroup !== "" && (
                  <span className="small error color-danger">
                    {errors?.newGroup}
                  </span>
                )}

              <div className="mb-15">
                <label htmlFor="name" className="text-sm font-medium dark:text-white">
                  Group Description
                </label>
                <Input
                  id="newGroupDescription"
                  placeholder="Group Description"
                  onChange={(event) => {
                    setNewGroupDescription(event.target.value);
                  }}
                  value={newGroupDescription ? newGroupDescription : ""}
                  className="mt-8"
                />
              </div>
              {/* <div className="mb-15">
                <label htmlFor="name" className="text-sm font-medium">
                  Group Type
                </label>
                <div className="mt-8">
                  <SingleSelectNew
                    name="groupType"
                    id="groupType"
                    placeholder="Group Type"
                    options={GroupType}
                    onChange={(value) => {
                      setNewGroupType(value);
                    }}
                    value={newGroupType ? newGroupType : ""}
                  />
                </div>
              </div> */}
              <div>
                <label htmlFor="name" className="text-sm font-medium dark:text-white">
                  Group Members
                </label>
                <div className="mt-8">
                  <MultiSelectWithCheckbox
                    value={selectedOptions}
                    onChange={setSelectedOptions}
                    options={employeeOptions}
                    placeholder="Select Members"
                  />
                </div>
              </div>
              <div className="mv-12 d-flex flex-justify-flexend pv-10">
                <Button
                  className="mr-10"
                  type="button"
                  variant="outline"
                  disabled={isLoading ? true : false}
                  onClick={() => props?.setIsEditOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  className="bg-green-600 hover:bg-green-700 color-white"
                  variant={"contained"}
                  onClick={onEditGroup}
                  disabled={isLoading ? true : false}
                >
                  {isLoading ? "Loading..." : "Update Group"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default EditGroup;
